module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C243"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/html/05_List_of_Illustrations#page_ix"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_Author_s_Note_on_Names#page_xvii"
    }
  }, [_vm._v("Author’s Note on Names")])])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_The_Huxley_Family_Tree#page_xviii"
    }
  }, [_vm._v("The Huxley Family Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/08_Introduction#page_xxi"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_PART_I__Genealogies#page_1"
    }
  }, [_vm._v("PART I: "), _c('em', [_vm._v("Genealogies")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1__Generations__The_Huxleys__182#page_3"
    }
  }, [_vm._v("1. Generations: The Huxleys, 1825–1975")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_2__Trustees_of_Evolution__The_In#page_44"
    }
  }, [_vm._v("2. Trustees of Evolution: The Intellectual Inheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_3__Malady_of_Thought__Huxley_Min#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Malady of Thought: Huxley Minds and Souls")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_PART_II__Animals#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: "), _c('em', [_vm._v("Animals")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_4__Creatures_of_the_Sea_and_Sky#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Creatures of the Sea and Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_5__Animal_Politics__From_Cruelty#page_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Animal Politics: From Cruelty to Conservation")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_6__Primates__Apes_and_the_Huxley#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Primates: Apes and the Huxleys")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_PART_III__Humans#page_233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: "), _c('em', [_vm._v("Humans")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_7__The_Man_Family__Sapiens_of_th#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Man Family: "), _c('em', [_vm._v("Sapiens")]), _vm._v(" of the Deep Past")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_8__Human_Difference__Sapiens_in#page_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Human Difference: "), _c('em', [_vm._v("Sapiens")]), _vm._v(" in the Political Present")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_9__Transhumans__Sapiens_of_the_E#page_328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Transhumans: "), _c('em', [_vm._v("Sapiens")]), _vm._v(" of the Eugenic Future")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_PART_IV__Spirits#page_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: "), _c('em', [_vm._v("Spirits")])])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_10__Other_Worlds__The_Re_enchant#page_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Other Worlds: The Re-enchantment of the Huxleys")])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/23_Epilogue__Birth__Death__Afterliv#page_410",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Birth, Death, Afterlives")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/24_Acknowledgements#page_421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/25_Notes#page_425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/26_Index#page_487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a866b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0